<template>
  <section class="banner" :class="{ banner_dark: active }">
    <div class="banner__text h2">
      Soda Connect works using the encrypted VLESS protocol
      <div class="toggle-btn__wrapper">
        <div class="toggle-btn" :class="{ active }" @click="active = !active" />
      </div>
      and is not tied to any specific VPN provider or hosting service.
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'

export default {
  setup() {
    const active = ref(false)

    return {
      active
    }
  }
}
</script>
